import { FC } from "react"
import './transporte.css'
import { TransporteTable } from "./TransporteTable/TransporteTable"
import { TransporteTableSimple } from "./TransporteTable/TransporteTableSimple"

export const Transporte:FC<any> = (props):JSX.Element => {

    const { data, setData, dataMASTER, setDataMASTER, simulated,original, comparativa, saveLoading, same , scenarioBase} = props

    return (
        <div className="transporte__wrapper">
            {
                comparativa?
                    <TransporteTable
                        scenarioBase={scenarioBase}
                        data={data}
                        dataMASTER={dataMASTER}
                        setData={setData}
                        setDataMASTER={setDataMASTER}
                        simulated={simulated}
                        original={original}
                        saveLoading={saveLoading}
                        same={same}
                    />
                :
                    <TransporteTableSimple
                        scenarioBase={scenarioBase}
                        data={data}
                        dataMASTER={dataMASTER}
                        setData={setData}
                        setDataMASTER={setDataMASTER}
                        simulated={simulated}
                        original={original}
                        saveLoading={saveLoading}
                    />
            }
            
        </div>
    )
}